import { render, staticRenderFns } from "./dbPermissionRequest.vue?vue&type=template&id=42e14e68&scoped=true&"
import script from "./dbPermissionRequest.vue?vue&type=script&lang=js&"
export * from "./dbPermissionRequest.vue?vue&type=script&lang=js&"
import style0 from "./dbPermissionRequest.vue?vue&type=style&index=0&id=42e14e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e14e68",
  null
  
)

export default component.exports